import {hostName} from "../../../endpoint";
import {defaultHeaders} from "../../../headers";

export const update = async (user) => {
  try {
    const result = await fetch(`${hostName}/business/team-staff`, {
      method: "PUT",
      headers: {
        ...defaultHeaders,
        Authorization: `Bearer ${localStorage.getItem("access_token")}`,
      },
      body: JSON.stringify(user),
    });
    return {
      hasSuccess: result.status === 200,
      data: await result.json(),
    };
  } catch (err) {
    return {
      hasSuccess: false,
      data: err.message,
    };
  }
};
